import React from "react";
import "../styles/Languages.css"; // new CSS file

// Dynamically import all images from src/assets/flags
function importAll(r) {
  return r.keys().map(r);
}

// Load all images in the folder (png, jpg, jpeg, webp, svg supported)
const flags = importAll(
  require.context("../assets/flags", false, /\.(png|jpe?g|avif|webp|svg)$/)
);

const Languages = () => {
  return (
    <section id="languages" className="languages section">
      <h2>Languages</h2>
      <p>We support a wide range of languages from around the world.</p>

      <div
        className="flags-scroller"
        role="marquee"
        aria-label="Scrolling country flags"
      >
        <div className="flags-track">
          {flags.concat(flags).map((flag, index) => (
            <img
              key={index}
              src={flag}
              alt={`Flag ${index + 1}`}
              className="flag"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Languages;
